// @flow
import React from "react";
import { Field } from "redux-form";
import { IconOptions } from "./IconOptions";
import { FIRST_OCCUPANCY, NEXT_POSSIBLE_DATE, RELOCATION, SWITCH_PROVIDER } from "../Constants";

type Props = { t: typeof TFunction, change: (field: string, value: ?any) => void };

export function ReasonForChange({ t, change }: Props) {
  return (
    <Field
      name="switchProviderOrMove"
      component={IconOptions}
      props={{
        options: [
          {
            icon: "coins",
            label: t("mobile.contract.reasonForChange.options.SWITCH"),
            value: SWITCH_PROVIDER,
            dataCy: SWITCH_PROVIDER,
          },
          {
            icon: "house",
            label: t("wizard.customer.firstOccupancy.options.FIRST_OCCUPANCY"),
            value: FIRST_OCCUPANCY,
            dataCy: FIRST_OCCUPANCY,
          },
          {
            icon: "truck",
            label: t("wizard.customer.firstOccupancy.options.RELOCATION"),
            value: RELOCATION,
            dataCy: RELOCATION,
          },
        ],
        onChange: (value) => {
          if (value === SWITCH_PROVIDER) {
            change("firstOccupancy", null);
            change("cancelOldContract", NEXT_POSSIBLE_DATE);
          }

          if (value === RELOCATION || value === FIRST_OCCUPANCY) {
            change("firstOccupancy", value);
            change("cancelOldContract", null);
          }
        },
      }}
    />
  );
}
